import { IonDate } from "../components/IonDate";
const CheckNotNull = Symbol('CheckNotNull');

class DocumentCategory {
    //from database
    public document_categoryID: string = '';
    public label: string = '';
    public is_newsletter: boolean = false;
    public creator_userID: string = '';
    public datetime_created: Date | null = null;
    public updater_userID: string = '';
    public datetime_updated: Date | null = null;
    constructor(
        document_categoryID: string,
        label: string,
        is_newsletter: string,
        creator_userID: string,
        datetime_created: string,
        updater_userID: string,
        datetime_updated: string
    ) {
        this.document_categoryID = this[CheckNotNull](document_categoryID) ? document_categoryID : '';
        this.label = this[CheckNotNull](label) ? label : '';
        this.is_newsletter = this[CheckNotNull](is_newsletter) ? (is_newsletter == '1' ? true : false) : false;
        this.creator_userID = this[CheckNotNull](creator_userID) ? creator_userID : '';
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : null;
        this.updater_userID = this[CheckNotNull](updater_userID) ? updater_userID : '';
        this.datetime_updated = this[CheckNotNull](datetime_updated) ? IonDate(datetime_updated) : null;
    }
    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0) 
            return true;
        else
            return false;
    }
}
export default DocumentCategory;